export default class Modal {
  constructor ({ title = null, text = [], callback } = {}) {
    this.title = title
    this.text = text
    this.callback = callback
  }

  get text_to_array () {
    return Array.isArray(this.text) ? this.text : [this.text]
  }
}
